// Job status options
export const JOB_STATUSES = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];

// Required roles for job updates
export const REQUIRED_ROLES = ['ADMIN', 'GUEST_APP_MANAGER', 'PROPERTY_MANAGER', 'HOUSEKEEPER_MANAGER'];

// Reservation view types
export const RESERVATION_VIEWS = {
  PREVIOUS: 'previous',
  CURRENT: 'current', 
  NEXT: 'next'
};

// Edit field types
export const EDIT_FIELDS = {
  CHECKIN: 'checkin',
  CHECKOUT: 'checkout'
};

// Assignment types
export const ASSIGNMENT_TYPES = {
  INDIVIDUAL: 'individual',
  TEAM: 'team'
};

// Tab types
export const TABS = {
  JOB: 'job',
  RESERVATION: 'reservation'
};

// Default times
export const DEFAULT_TIMES = {
  CHECK_IN: '16:00',
  CHECK_OUT: '11:00'
};

// Checkout time constraints (prevents day-shift from accidental midnight selection)
export const CHECKOUT_TIME_MIN = '10:00';
export const CHECKOUT_TIME_MAX = '16:00';

// Hour-only options for check-in (all 24 hours)
export const CHECKIN_HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => {
  const hour24 = i.toString().padStart(2, '0');
  const hour12 = i === 0 ? 12 : i > 12 ? i - 12 : i;
  const period = i < 12 ? 'AM' : 'PM';
  return { value: `${hour24}:00`, label: `${hour12}:00 ${period}` };
});

// Hour-only options for check-out (10 AM – 4 PM only)
export const CHECKOUT_HOUR_OPTIONS = Array.from({ length: 7 }, (_, i) => {
  const hour24 = (i + 10).toString().padStart(2, '0');
  const hour12 = (i + 10) > 12 ? (i + 10) - 12 : (i + 10);
  const period = (i + 10) < 12 ? 'AM' : 'PM';
  return { value: `${hour24}:00`, label: `${hour12}:00 ${period}` };
});